import React, {memo, useCallback, useRef, useState} from 'react';
import styles from './index.module.scss';
import arrow from "../../../../assets/icons/arrows/white_arrow_down.svg";
import CustomLink from "../../../CustomLink";
import {useOutsideClick} from "../../../../helpers/hooks";
import cx from "classnames";

interface Props {
  items: {
    title: string,
    text: string,
    icon: string
    link?: string,
    onClick?: () => void,
  }[],
  title: string,
  maxHeight?: number
}

const Dropdown = ({items, title, maxHeight = 250}: Props) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const outsideClickHandler = useCallback(() => {
    if (isOpen) setIsOpen(false)
  }, [isOpen]);
  useOutsideClick(outsideClickHandler, dropdownRef);
  return (
    <div className={styles.dropdownContainer}>
      <div className={styles.flex} onClick={setIsOpen.bind(null, true)}>
        <p className={styles.link}>{title}</p>
        <img src={arrow} alt="arrow down"/>
      </div>

      <div
        className={cx(styles.dropdownWrapper, {[styles.active]: isOpen})}
        style={{maxHeight: isOpen ? maxHeight : 0}}>
        <div className={styles.dropdown} ref={dropdownRef}>
          {items.map(({title, text, link, icon, onClick}, i) => (
            <CustomLink to={link} key={i}>
              <div className={styles.subItem} onClick={onClick}>
                <img src={icon} alt="Icon"/>
                <div className={styles.flex}>
                  <p className={styles.subItem__title}>{title}</p>
                  <p className={styles.subItem__text}>{text}</p>
                </div>
              </div>
            </CustomLink>
          ))}
        </div>
      </div>
    </div>
  )
}

export default memo(Dropdown)
